export async function encodeGradeForView(gradeName: string): Promise<number> {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/strict-boolean-expressions
    if (!crypto.subtle) {
        throw new Error('Web Crypto API not available. HTTPS or localhost required.');
    }
    const encoder = new TextEncoder();
    const data = encoder.encode(gradeName);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const dataView = new DataView(hashBuffer);
    return dataView.getUint32(0, false);
}
